Vendd.Scripts.load(function () {
    var $wrapper = $('.x-instagram-feed'),
        $instaList = $('.instagram-list', $wrapper);

    if ($wrapper.length < 1)
        return;

    //Waiting core issue VENDDTHREE-5277
    //$wrapper.on('click', '.image-container', function (e) {
    //    e.preventDefault();
    //    $wrapper.addClass('x-loading');
    //    var link = 'https://api.instagram.com/oembed?url=' + $(this).data('link');
    //    $.ajax({
    //        type: 'GET',
    //        url: link,
    //        async: true,
    //        data: { get_param: 'html' },
    //        success: function (data) {
    //            var temp = data;
    //            $('#insta-post').html(temp.html);
    //            $('.fancy-open').trigger("click");
    //            if (typeof window.instgrm !== 'undefined') {
    //                window.instgrm.Embeds.process();
    //            }
    //            $wrapper.removeClass('x-loading');

    //        }
    //    });
    //    $('.fancy-open').fancybox({
    //        toolbar: false,
    //        smallBtn: true,
    //        hash: null,
    //        afterClose: function () {
    //            $('#insta-post').html('');
    //        },
    //    });

    //});
});

